import { AzzurroHubDataType, ConnextData, PlantDeviceType, PowerFlowGraphMode, System, VirtualRTStateType } from 'ngx-core-services';

type SystemSubscriptionState = 'subscribed' | 'unsubscribed' | 'subscribing' | 'unsubscribing' | 'pending' | 'error';
export type SystemStructure = PowerFlowGraphMode;

export type SystemDefinition =
  | ({
      monitoringType: 'Connext';
      data?: Partial<ConnextData>;
    } & BaseSystemDefinition)
  | ({
      monitoringType: 'Solarman';
      data?: undefined;
    } & BaseSystemDefinition)
  | ({
      monitoringType: 'AzzurroHub';
      data?: Partial<AzzurroHubDataType>;
    } & BaseSystemDefinition);

interface BaseSystemDefinition extends System {
  subscription: SystemSubscriptionState;
  metadata?: {
    tz: number;
    structure: SystemStructure;
    isConnected?: boolean;
    invertMeterSensor?: boolean;
    location?: { lat: string; lng: string };
    userLevel?: number;
    verifiedDevices?: PlantDeviceType[];
    verifiedUninstallations?: PlantDeviceType[];
  };
  isMetadataLoading?: boolean;
  virtualRTStatus?: VirtualRTStateType;
}

export interface SystemList {
  [SystemId: string]: SystemDefinition;
}

export interface SystemsState {
  selectedSystemUid?: string;
  systemList: SystemList;
  temporarySystemState?: {
    [SystemId: string]: 'inProgress' | 'success' | 'error';
  };
  observers: {
    [SystemId: string]: {
      [ObserverId: string]: number
    }
  };
}

export const initialSystemState: SystemsState = {
  systemList: {},
  observers: {},
};
